<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
         class="red--text mr-2 icon__size-50"
          v-on="on"
          v-bind="attrs"
        >
          {{ statusIcon }}
        </v-icon>
      </template>
      <span v-if="$route.name === 'terminated.detail'">{{ $t('text.draft-is-terminated') }}</span>
      <span v-else>{{ $t('text.memo-is-revoked') }}</span>
    </v-tooltip>
  </div>
</template>
<script>
import {
  mdiTextBoxRemoveOutline,
  mdiStepBackward2
} from "@mdi/js";
export default {
  name: "header-right",
  data: () => ({
   iconRevoked : mdiStepBackward2,
   iconTerminated : mdiTextBoxRemoveOutline 
  }),
  computed: {
    statusIcon() {
      if (this.$route.name === 'terminated.detail') return this.iconTerminated;
      else return this.iconRevoked;
    },
  },
};
</script>